import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useCombobox } from 'downshift';
import React, { useRef } from 'react';
import { ComboBox } from "./ComboBox";
import { ComboBoxInputSelect } from "./ComboBoxInputSelect";
import { ComboBoxItem } from "./ComboBoxItem";
import { ComboBoxPopoverList } from "./ComboBoxPopoverList";
import { singleSelectStrategy } from "./strategies";
/**
 * A convenience wrapper around ComboBox meant for selecting
 * a single list item. For more flexibility, you can use the composite
 * elements of this component.
 */

export function ComboBoxSingleSelect(_ref) {
  var query = _ref.query,
      selectedItem = _ref.selectedItem,
      _onSelectedItemChange = _ref.onSelectedItemChange,
      _ref$inputSize = _ref.inputSize,
      inputSize = _ref$inputSize === void 0 ? 'medium' : _ref$inputSize,
      placeholder = _ref.placeholder,
      itemToString = _ref.itemToString,
      items = _ref.items,
      _ref$popoverWidth = _ref.popoverWidth,
      popoverWidth = _ref$popoverWidth === void 0 ? '200px' : _ref$popoverWidth,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["query", "selectedItem", "onSelectedItemChange", "inputSize", "placeholder", "itemToString", "items", "popoverWidth", "children"]);

  var inputContainerRef = useRef(null);

  function renderItems() {
    if (children) {
      return children;
    }

    if (items.length) {
      return items.map(function (item, i) {
        return /*#__PURE__*/React.createElement(ComboBoxItem, {
          index: i,
          item: item,
          key: itemToString(item)
        }, itemToString(item));
      });
    }

    return null;
  }

  return /*#__PURE__*/React.createElement(ComboBox, _extends({
    items: items,
    query: query,
    itemToString: itemToString,
    stateReducer: singleSelectStrategy,
    selectedItem: selectedItem,
    defaultHighlightedIndex: selectedItem && !query ? undefined : 0,
    onSelectedItemChange: function onSelectedItemChange() {
      _onSelectedItemChange.apply(void 0, arguments);
    },
    onStateChange: function onStateChange(state) {
      if (state.type === useCombobox.stateChangeTypes.ItemClick || state.type === useCombobox.stateChangeTypes.InputKeyDownEnter) {
        inputContainerRef.current.focus();
      }
    }
  }, other), /*#__PURE__*/React.createElement(ComboBoxInputSelect, {
    ref: inputContainerRef,
    size: inputSize,
    placeholder: placeholder,
    itemToString: itemToString
  }), /*#__PURE__*/React.createElement(ComboBoxPopoverList, {
    width: popoverWidth,
    animationDuration: 250
  }, renderItems()));
}